<div (click)="update()">
  <input type="checkbox" [checked]="checked"/>
  <label class="ml-auto">Toggle</label>
</div>
